/**
 * Org detail → Configuration → Policies (GDN-2407).
 *
 * The org-scoped counterpart of the global Cortex Policies page: lists,
 * creates, and edits cortex policies with scope=organization for this org.
 * Same lifecycle UX (draft → promote, supersede, deprecate) via the shared
 * CortexPoliciesPanel. Global rows are deliberately not shown here —
 * runtime resolvers merge org + global; this surface manages the org's
 * own rows only.
 */

import { Box, Typography } from '@mui/material';

import { CortexPoliciesPanel } from './cortex-policies-panel';

interface OrganizationPoliciesSectionProps {
  organizationId: string;
}

export function OrganizationPoliciesSection({
  organizationId,
}: OrganizationPoliciesSectionProps) {
  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6">Policies</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Policies scoped to this organization (scheduling gates, confirmation
          and manage rules, operational config). Global policies still apply
          at runtime alongside these — manage those from Cortex Policies.
        </Typography>
      </Box>
      <CortexPoliciesPanel scope="organization" organizationId={organizationId} />
    </Box>
  );
}
